<template>
	<div>
		<div v-if="!isLoading">
			<div v-if="months.length">
				<div
					v-for="month in months"
					:key="month.month_start"
					class="mb-10"
				>
					<div class="flex items-center justify-between mb-2">
						<div class="text-neutral-600 font-semibold text-lg">
							Tháng {{ monthLabel(month.month_start) }}
						</div>
						<button
							type="button"
							class="flex items-end text-neutral-400 font-semibold text-xs"
							@click="month.expanded = !month.expanded"
						>
							<svg
								v-if="month.expanded"
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M15 12.5L9.99999 7.5L4.99999 12.5"
									stroke="#94A3B8"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<svg
								v-else
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M5 7.50001L10 12.5L15 7.50001"
									stroke="#94A3B8"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<span>{{
								month.expanded ? 'Thu gọn' : 'Mở rộng'
							}}</span>
						</button>
					</div>
					<div class="flex flex-col gap-4">
						<div
							class="grid grid-cols-2 gap-5 md-down:grid-cols-1"
						>
							<div
								class="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between"
							>
								<div class="flex items-center">
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
											fill="#94A3B8"
										/>
										<path
											d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
											fill="#94A3B8"
										/>
									</svg>
									<div class="text-neutral-500 text-sm ml-2">
										Học sinh
									</div>
								</div>
								<div
									class="text-neutral-600 font-bold text-4xl leading-8 tracking-tight"
								>
									{{
										ratio(
											month.student_stats
												?.students_have_session,
											month.student_stats?.total_students
										)
									}}
								</div>
							</div>
							<div
								class="bg-white p-4 rounded-lg shadow-sm flex items-center justify-between"
							>
								<div class="flex items-center">
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z"
											fill="#94A3B8"
										/>
									</svg>
									<div class="text-neutral-500 text-sm ml-2">
										Giờ can thiệp
									</div>
								</div>
								<div
									class="text-neutral-600 font-bold text-4xl leading-8 tracking-tight"
								>
									{{
										ratio(
											month.hours_stats
												?.total_non_cancelled_hours,
											month.hours_stats?.total_hours
										)
									}}
								</div>
							</div>
						</div>
						<div
							v-if="month.expanded"
							class="shadow-sm sm:rounded-2xl overflow-hidden"
						>
							<div
								class="__record__table overflow-x-auto scroll-bar"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="px-6 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
											>
												STT
											</th>
											<th
												scope="col"
												class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
											>
												<div
													class="flex items-center justify-between"
												>
													<span>Học sinh</span>
													<button
														type="button"
														class="ml-2"
														@click="
															toggleNameSort(
																month
															)
														"
													>
														<svg
															width="16"
															height="16"
															viewBox="0 0 16 16"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																fill-rule="evenodd"
																clip-rule="evenodd"
																d="M8 2.4C8.21217 2.4 8.41566 2.48429 8.56569 2.63431L10.9657 5.03432C11.2781 5.34673 11.2781 5.85327 10.9657 6.16569C10.6533 6.47811 10.1467 6.47811 9.83431 6.16569L8 4.33137L6.16569 6.16569C5.85327 6.47811 5.34673 6.47811 5.03431 6.16569C4.72189 5.85327 4.72189 5.34673 5.03431 5.03431L7.43431 2.63431C7.58434 2.48429 7.78783 2.4 8 2.4ZM5.03431 9.83432C5.34673 9.5219 5.85327 9.5219 6.16569 9.83432L8 11.6686L9.83431 9.83432C10.1467 9.5219 10.6533 9.5219 10.9657 9.83432C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56569 13.3657C8.25327 13.6781 7.74673 13.6781 7.43431 13.3657L5.03431 10.9657C4.72189 10.6533 4.72189 10.1467 5.03431 9.83432Z"
																fill="#94A3B8"
															/>
														</svg>
													</button>
												</div>
											</th>
											<th
												scope="col"
												class="px-6 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												style="width: 262px"
											>
												Giờ học lớp nhóm
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												item, index
											) in studentsFor(month)"
											:key="
												item.student_id ||
												item.student?.id ||
												index
											"
											:class="
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700 cursor-pointer hover:bg-orange-50"
											@click="openStudent(item, month)"
										>
											<td
												class="px-2 py-4 text-center text-neutral-700"
											>
												{{ index + 1 }}
											</td>
											<td class="px-6 py-4">
												<div
													class="flex items-center"
												>
													<img
														v-if="
															item.student
																?.profile_photo
																?.w200
														"
														class="shadow-sm inline-block h-6 w-6 rounded-full"
														:src="
															item.student
																.profile_photo
																.w200
														"
														alt=""
													/>
													<span
														v-else
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
														:style="{
															background:
																item.student
																	?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="text-xs font-medium leading-none text-white"
															>{{
																item.student
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
													<div
														class="ml-3 font-semibold text-orange-500 truncate"
													>
														{{
															item.student?.name
														}}
													</div>
												</div>
											</td>
											<td
												class="px-2 py-4 text-center text-neutral-700 whitespace-nowrap"
											>
												{{
													ratio(
														item.total_non_cancelled_hours,
														item.total_hours
													)
												}}
											</td>
										</tr>
										<tr
											v-if="!studentsFor(month).length"
										>
											<td
												colspan="3"
												class="px-6 py-8 text-center text-neutral-500 bg-white"
											>
												Không có học sinh
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<DaInfinityLoading
					v-if="showInfinityLoading"
					:loaded="stopLoad"
					:is-loading="isFetching"
					@infinite-load="getMonthlyStats"
				/>
			</div>
			<div
				v-else
				class="w-full mt-20 flex items-center justify-center flex-col"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div class="text-neutral-500 text-lg text-center mt-4">
					Không có dữ liệu thống kê
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading';
import Loading from '@/components/common/Loading';
import { $api } from '@/services';
import { toEnglish } from '@/helper/toEnglish';

export default {
	name: 'ScheduleStatsGroup',

	components: {
		DaInfinityLoading,
		Loading,
	},

	props: {
		searchQuery: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			months: [],
			nextMonthStart: null,
			isLoading: true,
			isFetching: false,
			stopLoad: false,
			showInfinityLoading: false,
		};
	},

	created() {
		this.getMonthlyStats();
	},

	beforeUnmount() {
		this.showInfinityLoading = false;
	},

	methods: {
		monthLabel(date) {
			return dayjs(date).format('MM / YYYY');
		},

		ratio(actual, total) {
			const left =
				actual === null || actual === undefined || actual === ''
					? 0
					: actual;
			const right =
				total === null || total === undefined || total === ''
					? 0
					: total;
			return `${left}/${right}`;
		},

		studentsFor(month) {
			const query = (this.searchQuery || '').trim().toLowerCase();
			const list = [...(month.student_hours_stats || [])];
			const filtered = query
				? list.filter((item) =>
						toEnglish(item?.student?.name || '')
							.toLowerCase()
							.includes(query)
				  )
				: list;

			if (month.nameSort === 'asc' || month.nameSort === 'desc') {
				filtered.sort((a, b) => {
					const left = toEnglish(
						a?.student?.name || ''
					).toLowerCase();
					const right = toEnglish(
						b?.student?.name || ''
					).toLowerCase();
					const result = left.localeCompare(right);
					return month.nameSort === 'asc' ? result : -result;
				});
			}

			return filtered;
		},

		toggleNameSort(month) {
			if (month.nameSort === 'asc') {
				month.nameSort = 'desc';
			} else if (month.nameSort === 'desc') {
				month.nameSort = null;
			} else {
				month.nameSort = 'asc';
			}
		},

		openStudent(item, month) {
			const studentId = item?.student_id || item?.student?.id;
			if (!studentId) return;
			this.$router.push({
				path: '/schedule/stats/student/group-class',
				query: {
					student_id: studentId,
					date: month.month_start,
				},
			});
		},

		async getMonthlyStats() {
			if (this.stopLoad || this.isFetching) return;
			this.isFetching = true;
			try {
				const monthStart =
					this.nextMonthStart ||
					dayjs().startOf('month').format('YYYY-MM-DD');
				const { data } = await $api.schedule.groupClassMonthlyStats({
					month_start: monthStart,
				});
				const month = data?.month_start ? data : data?.data;
				if (!month?.month_start) {
					this.stopLoad = true;
					return;
				}
				if (
					this.months.some(
						(item) => item.month_start === month.month_start
					)
				) {
					this.stopLoad = true;
					return;
				}
				this.months.push({
					...month,
					expanded: true,
					nameSort: null,
					student_hours_stats: month.student_hours_stats || [],
				});
				if (
					!month.previous_month ||
					month.previous_month === month.month_start
				) {
					this.stopLoad = true;
				} else {
					this.nextMonthStart = month.previous_month;
				}
			} catch (error) {
				console.log(error);
				this.stopLoad = true;
			} finally {
				this.isLoading = false;
				this.isFetching = false;
				this.showInfinityLoading = true;
			}
		},
	},
};
</script>
